const a0_0xbfe7 = [
    'w7fDucONZ8KVD2LChcK6BsOTbsKOScOYSGlJwqI8WcOlwqHDuxYOZEMiJH7CsyvDrMKhZSvDj8KXw7fCn8K0w5HDhMOgwqV+MEQJASzDhcKWL8KCVHPDhMOpwp1kw53Ctl1pUSzDhWfDlsK0',
    'woMew5bDsMKMaxzCh8Kjw7sIw6cbw4XDkEdTwrQNasOiOsOVbsOGLC/CucOuC8OMwpPDv8Omw7tLwplIFSvCusKcFsO2woLDpgrCg8OlwojCmlglwqfDqEJBw5pHesOOw7U+csOASsO9Bk5qw7lN',
    'wqdFJwI=',
    'dcOfOMOfVMOEwonCuMK9w5bDi8OPw6p8TQHDjwfDvUHCngXDjMOGF8KpSRQ2w4hfwo5xdQY1w4Aow63Cg0QPQcOkAnYNI1XCsA7CrsOYYMKTcMK9wrfCpT3CgsKHwrkQFSLDjRnDpH12woE=',
    'HUwYw6PDosKwMMK4wpzCo8OCw5giwpXDhMOqwonDtCMtw6PCgEzCr8K+WMKcwqw+w5XDlcKmw7zDuW1Z',
    'wqp8WTJ0N8KPNQPDpsODVMKkw51MJTTCh8K7wrBIZ8KEw6PDizPCocO6Y8KxCMKfw7cnHFI=',
    'wpR4w54TMlJ1w77CphXCm1laQsK4cMOMLDLDsMKiw4c0SMKfBncCw54LBMKdGSQbw6nCmCXCkw==',
    'w4USeynDtMOCJUk=',
    'w54eZXFkQsKHFmPDoDjCvcKiw5pD',
    'wqV+ATI=',
    'aRvDucKCBlpHSMKsDMOjCW4HOwRswr/DkMOUw4bDvcK3wofDohkYw4nDl8O5ZgLDrMKHPBzCjwfDkQ==',
    'IMO+RMKR',
    'w4LDv8KlwrRkwqwkwqYwT8Oua2F3djzCmU13CU9Lw5HCnsKAwoQxUA5yS8O0R0UtYw==',
    'w6zCrcKowqZKUFHDqkDCqQcGw6XDisKLW8OeNcODw4PCrcOkwp/DrcOsw6nDksKNwpsBwr8cw4nDvDgEw7Q8w6sILHDCjsOKHU8EwrZiIMOGwpLDvSpUw6tWw4zCgsKnw7DClwzCpn7Dhy/DjCNmwpnCjjYWKSd3T8OKQ1LDuMKVMcO1QMOMMsK4UcKZMEALbkjDvcKIfgpdw4jCm0zChD7CqQ==',
    'wrPDhMOvw6HCsMKyJF1pYcKow4LDvlTCqsKHw5BiH8KyPFnCqcOPw5cuPhsJTsOwTR03w4xY',
    'wqYkwp1N',
    'wpvChMOgP8Kjwpccw7pHwoRA',
    'Mm7DlFrCs08d',
    'w6kPZHFzScOsMXs=',
    'wrHCv8KaOcOPUTw=',
    'VMOww7BLCwFecsO+w63CoMOTwrgfFsK6woMKw5LCtR1gwrFk',
    'wr89woZz'
];
(function (_0x249ac9, _0xbfe791) {
    const _0x1e1376 = function (_0x1206d7) {
        while (--_0x1206d7) {
            _0x249ac9['push'](_0x249ac9['shift']());
        }
    };
    _0x1e1376(++_0xbfe791);
}(a0_0xbfe7, 0xfd));
const a0_0x1e13 = function (_0x249ac9, _0xbfe791) {
    _0x249ac9 = _0x249ac9 - 0x0;
    let _0x1e1376 = a0_0xbfe7[_0x249ac9];
    if (a0_0x1e13['KNBMTQ'] === undefined) {
        (function () {
            const _0x4537c2 = function () {
                let _0x2540a9;
                try {
                    _0x2540a9 = Function('return\x20(function()\x20' + '{}.constructor(\x22return\x20this\x22)(\x20)' + ');')();
                } catch (_0x1c434a) {
                    _0x2540a9 = window;
                }
                return _0x2540a9;
            };
            const _0x358d16 = _0x4537c2();
            const _0x22b8db = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
            _0x358d16['atob'] || (_0x358d16['atob'] = function (_0x24347f) {
                const _0x366940 = String(_0x24347f)['replace'](/=+$/, '');
                let _0x4880df = '';
                for (let _0x50dc0d = 0x0, _0x1edd99, _0xc2ee2b, _0x135ac8 = 0x0; _0xc2ee2b = _0x366940['charAt'](_0x135ac8++); ~_0xc2ee2b && (_0x1edd99 = _0x50dc0d % 0x4 ? _0x1edd99 * 0x40 + _0xc2ee2b : _0xc2ee2b, _0x50dc0d++ % 0x4) ? _0x4880df += String['fromCharCode'](0xff & _0x1edd99 >> (-0x2 * _0x50dc0d & 0x6)) : 0x0) {
                    _0xc2ee2b = _0x22b8db['indexOf'](_0xc2ee2b);
                }
                return _0x4880df;
            });
        }());
        const _0x163c47 = function (_0x281524, _0x414bf9) {
            let _0x10f4b8 = [], _0x494434 = 0x0, _0x414c65, _0x26f398 = '', _0x14368c = '';
            _0x281524 = atob(_0x281524);
            for (let _0xeae330 = 0x0, _0x47368b = _0x281524['length']; _0xeae330 < _0x47368b; _0xeae330++) {
                _0x14368c += '%' + ('00' + _0x281524['charCodeAt'](_0xeae330)['toString'](0x10))['slice'](-0x2);
            }
            _0x281524 = decodeURIComponent(_0x14368c);
            let _0x468b40;
            for (_0x468b40 = 0x0; _0x468b40 < 0x100; _0x468b40++) {
                _0x10f4b8[_0x468b40] = _0x468b40;
            }
            for (_0x468b40 = 0x0; _0x468b40 < 0x100; _0x468b40++) {
                _0x494434 = (_0x494434 + _0x10f4b8[_0x468b40] + _0x414bf9['charCodeAt'](_0x468b40 % _0x414bf9['length'])) % 0x100;
                _0x414c65 = _0x10f4b8[_0x468b40];
                _0x10f4b8[_0x468b40] = _0x10f4b8[_0x494434];
                _0x10f4b8[_0x494434] = _0x414c65;
            }
            _0x468b40 = 0x0;
            _0x494434 = 0x0;
            for (let _0x302f4a = 0x0; _0x302f4a < _0x281524['length']; _0x302f4a++) {
                _0x468b40 = (_0x468b40 + 0x1) % 0x100;
                _0x494434 = (_0x494434 + _0x10f4b8[_0x468b40]) % 0x100;
                _0x414c65 = _0x10f4b8[_0x468b40];
                _0x10f4b8[_0x468b40] = _0x10f4b8[_0x494434];
                _0x10f4b8[_0x494434] = _0x414c65;
                _0x26f398 += String['fromCharCode'](_0x281524['charCodeAt'](_0x302f4a) ^ _0x10f4b8[(_0x10f4b8[_0x468b40] + _0x10f4b8[_0x494434]) % 0x100]);
            }
            return _0x26f398;
        };
        a0_0x1e13['qQJmMo'] = _0x163c47;
        a0_0x1e13['hzGXUg'] = {};
        a0_0x1e13['KNBMTQ'] = !![];
    }
    const _0x1206d7 = a0_0x1e13['hzGXUg'][_0x249ac9];
    if (_0x1206d7 === undefined) {
        if (a0_0x1e13['nXGvQs'] === undefined) {
            a0_0x1e13['nXGvQs'] = !![];
        }
        _0x1e1376 = a0_0x1e13['qQJmMo'](_0x1e1376, _0xbfe791);
        a0_0x1e13['hzGXUg'][_0x249ac9] = _0x1e1376;
    } else {
        _0x1e1376 = _0x1206d7;
    }
    return _0x1e1376;
};
import { isDev } from '../utils/IsDev';
import { projectConfig } from '../project-info/projectConfig';
import { paymentConfig } from '../project-info/paymentConfig';
const env = isDev() ? a0_0x1e13('0x8', '8Cws') : a0_0x1e13('0x4', ')w]^');
let stripeKey;
if (env !== a0_0x1e13('0xd', 'nd^W'))
    stripeKey = a0_0x1e13('0x2', 'LBpX');
else
    stripeKey = paymentConfig[a0_0x1e13('0x7', '[mi9')];
export const STRIPE_KEY = stripeKey;
export const MELISSA_ID = a0_0x1e13('0x9', '2![(');
export const GOOGLE_MAP_API_KEY = a0_0x1e13('0x15', 'MySw');
let openGraphKey;
if (projectConfig[a0_0x1e13('0xa', 'a*KF')] == a0_0x1e13('0x13', '[mi9')) {
    openGraphKey = a0_0x1e13('0x3', 'trLC');
} else if (projectConfig[a0_0x1e13('0x0', 'alRi')] == a0_0x1e13('0x6', '3J#J')) {
    openGraphKey = a0_0x1e13('0x10', 'c!NF');
} else if (projectConfig[a0_0x1e13('0x14', 'c!NF')] == a0_0x1e13('0x12', 'QW0h')) {
    openGraphKey = a0_0x1e13('0x1', 'YOOL');
} else {
    openGraphKey = a0_0x1e13('0xf', 'zdfW');
}
export const OPENGRAPH_API_KEY = openGraphKey;
export const GCM_SENDER_ID = projectConfig[a0_0x1e13('0x5', '7zoT')];
const ANDROID_WEBCLIENT_ID = a0_0x1e13('0xc', 'Pa[I');
const WEBCLIENT_ID = a0_0x1e13('0xe', 'Knyr');
const IOS_CLIENT_ID = a0_0x1e13('0xb', '8Cws');
export const GOOGLE_CLIENT_IDS = {
    'android_webclient_id': ANDROID_WEBCLIENT_ID,
    'webclient_id': WEBCLIENT_ID,
    'ios_client_id': IOS_CLIENT_ID
};
export const GOOGLE_REACT_API_KEY = a0_0x1e13('0x11', 'KMW[');